export default __webpack_public_path__ + "static/P_SearchThumb_IN-8003HD-1961471e2c97b85e42401a8f96519203.webp";